import { STEP } from '../@types/state'
import { updateIntent, updateOwnership, updateTimeHorizon } from '../store/lead/leadSlice'
import { store } from '../store/store'
import { Intent } from '../@types/intent'
import { TimeHorizon } from '../@types/timeHorizon'
import { Ownership } from '../@types/ownership'
import { Flow } from '../@types/config'

export const getSkippedStepsForEmbedJSCode = (): STEP[] => {
  const RLE_INTEGRATION_ID = 'rle-wizard'

  const rleWizardDiv: HTMLElement | null = document.getElementById(RLE_INTEGRATION_ID)
  return addDeeplInksToJSEmbedCode(rleWizardDiv)
}

export const intentFromEmbedCode = ['SELL', 'RENT', 'LET', 'BUY']

export const addDeeplInksToJSEmbedCode = (rleWizard: HTMLElement | null): STEP[] => {
  const skippedSteps: STEP[] = []

  if (rleWizard != null) {
    const intent = rleWizard.getAttribute('intent')
    const sellTime = rleWizard.getAttribute('selltime')
    const ownership = rleWizard.getAttribute('ownership')
    const realtor = rleWizard.getAttribute('realtor')
    const flowType = rleWizard.getAttribute('data-flow-type')

    if (flowType != Flow.SOLAR) presetStoreForEmbedJSCode(intent, sellTime, ownership, realtor)

    if (intentFromEmbedCode.includes(intent?.toUpperCase() as string)) skippedSteps.push(STEP.INTENT)
    if (
      [TimeHorizon.IMMEDIATELY, TimeHorizon.LATER, TimeHorizon.NEXT_SIX_MONTHS, TimeHorizon.NEXT_TWO_YEARS].includes(
        sellTime?.toUpperCase() as TimeHorizon
      )
    )
      skippedSteps.push(STEP.TIME_HORIZON)
    if (
      [Ownership.YES, Ownership.NO, Ownership.CO_OWNER, Ownership.RELATIVE].includes(
        ownership?.toUpperCase() as Ownership
      )
    )
      skippedSteps.push(STEP.OWNER)
    if (['YES', 'NO'].includes(realtor?.toUpperCase() as string))
      skippedSteps.push(STEP.SELL_INTENT, STEP.REINFORCEMENT, STEP.DEV_COM_OFFER, STEP.PARTIAL_SALE)
  }

  return skippedSteps
}

const presetStoreForEmbedJSCode = (
  intent: string | null,
  selltime: string | null,
  ownership: string | null,
  realtor: string | null
) => {
  if (intentFromEmbedCode.includes(intent as string)) store.dispatch(updateIntent(intent?.toUpperCase() as Intent))
  if (
    [TimeHorizon.IMMEDIATELY, TimeHorizon.LATER, TimeHorizon.NEXT_SIX_MONTHS, TimeHorizon.NEXT_TWO_YEARS].includes(
      selltime?.toUpperCase() as TimeHorizon
    )
  )
    store.dispatch(updateTimeHorizon(selltime?.toUpperCase() as TimeHorizon))
  if ([Ownership.YES, Ownership.NO, Ownership.CO_OWNER, Ownership.RELATIVE].includes(ownership as Ownership))
    store.dispatch(updateOwnership(ownership as Ownership))

  if (realtor?.toUpperCase() === 'YES') store.dispatch(store.dispatch(updateIntent(Intent.MAKLER_SALE)))
  else if (realtor?.toUpperCase() === 'NO') store.dispatch(updateIntent(Intent.INDEPENDENT_SALE))
}
